import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router-dom'
import update from 'react-addons-update'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import qs from 'qs'
import PendingTeacherBar from 'pobble-components/dist/pending-teacher-bar'
import { withMe } from 'pobble-components/dist/pobble-user'

import Masonry from 'react-masonry-component'
import debounce from 'lodash.debounce'

import Campaigns from './Campaigns'
import WorkTile from './WorkTile'
import SearchHeader from './SearchHeader'
// import SchoolHeader from './SchoolHeader'
import SchoolHeader from './SchoolCelebrationHeader'
import ResourceHeader from './ResourceHeader'
import StudentHeader from './StudentHeader'
import NotFound from './notFound'

import API from '../api'

import WorkEnvelope from './WorkEnvelope'
import './Search.css'

import FaDownload from 'react-icons/fa/download'


const masonryOptions = {
  fitWidth: true,
  gutter: window.innerWidth > 500 ? 30 : 10
}

@autobind
class Search extends Component {
  constructor (props) {
    super(props)
    this.props.match.params.schoolId === 'my-school' && this.redirectToMySchool()
    const limit = window.innerWidth > 800 ? 30 : 12
    var groupId = this.props.match.params.groupId
    var schoolId = this.props.match.params.schoolId
    var resourceId = this.props.match.params.resourceId
    var studentId = this.props.match.params.studentId
    var query = this.props.match.params.query

    this.state = {page: 0, limit, filters: { }, query, works: [], loading: true, schoolId, resourceId, studentId, scrollTop: 0, school: {}, user: {}}
    this.onSearchScroll = debounce(this.checkInfiniteScroll, 100)
  }

  componentWillMount () {
    let state = localStorage.getItem('backToSearch')
    if (state) {
      try {
        state = JSON.parse(state)
        this.setState(state, () => {
          localStorage.removeItem('backToSearch')
          window.scroll(0, state.scrollTop)
          window.addEventListener('scroll', this.onSearchScroll)
        })
      } catch (e) {
        localStorage.removeItem('backToSearch')
      }
    } else {
      this.cleanSearch()
      this.props.match.params.schoolId && this.getSchoolInfo(this.props.match.params.schoolId)
      this.getUserInfos()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.onSearchScroll)
  }

  componentWillReceiveProps ({params: {schoolId, query} = {}} = {}) {
    this.setState({ schoolId, query }, schoolId
      ? this.getSchoolInfo(schoolId)
      : this.cleanSearch())
  }

  redirectToMySchool () {
    if (this.props.me.account.teacher_type && this.props.me.account.teacher_type.school && this.props.me.account.teacher_type.school.id) {
      this.props.history.push(`/schools/${this.props.me.account.teacher_type.school.id}`)
    }
    if (this.props.me.account.student_type && this.props.me.account.student_type.school && this.props.me.account.student_type.school.id) {
      this.props.history.push(`/schools/${this.props.me.account.student_type.school.id}`)
    }
  }

  getUserInfos () {
    API.get('/v3/me?include=account.student_type,account.student_type.school').then(({data}) => this.setState({user: data.account}))
  }

  getSchoolInfo (schoolId) {
    API.get(`/v3/schools/${schoolId}?include=school.names,school.address,school.contact_details,school.groups,school.group.names,school.group.visibility,school.group.stats,school.group.counters,school.followed_by_current_account,school.work_counters,school.logo,school.background_image,school.website,school.twitter_handler`).then(({data: {school}}) => this.setState({ school }))
  }

  appendWorks (works) {
    this.setState({works: [].concat(this.state.works, works)})
    this.checkInfiniteScroll()
    return works
  }

  checkScroll () {
    this.setState({scrollTop: window.pageYOffset})
    return document.body.clientHeight - (window.innerHeight + window.pageYOffset) < 500
  }

  checkInfiniteScroll () {
    !this.state.loading && this.checkScroll() && this.onSearch().then(this.appendWorks)
  }

  onFilterSelect (filters) {
    this.setState({filters: Object.assign({}, this.state.filters, filters)}, this.cleanSearch)
  }

  cleanSearch () {
    window.addEventListener('scroll', this.onSearchScroll)
    this.setState({page: 0, done: false}, () => {
      this.onSearch().then(works => {
        this.setState({ loading: false, works })
      })
    })
  }

  goToQuery (query) {
    let school = this.state.schoolId ? `/school/${this.state.schoolId}` : ''
    let resource = this.state.resourceId ? `/resource/${this.state.resourceId}` : ''
    let student = this.state.studentId ? `/students/${this.state.studentId}` : ''
    query.length && this.props.history.push(`/search/${query}${school}${resource}${student}`)
    !query.length && this.props.history.push(`/`)
    this.setState({ query })
  }

  stopScroll () {
    this.setState({done: true})
    window.removeEventListener('scroll', this.onSearchScroll)
  }

  onSearch () {
    let searchInput = document.getElementById('searchInput')
    const url = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    let query = this.props.match.params.query || (url && url.lessonTitle)
    let schoolId = this.props.match.params.schoolId
    let { page, limit, filters: { bookmark, exemplar, order, yeargroup, groupId, student }, resourceId, studentId, user } = this.state
    query = query && query.length ? `&search_string=${query}` : ''
    schoolId = schoolId ? `&school_id=${schoolId}` : ''
    groupId = groupId ? `&group_id=${groupId}` : ''
    bookmark = bookmark ? '&bookmarked=1' : ''
    exemplar = exemplar ? '&exemplar=1' : ''
    order = order ? `&order=${order}` : ''
    yeargroup = yeargroup ? `&year_group_id=${yeargroup}` : ''
    student = student ? `&${student}=${student === 'student_id' ? user.id : user.student_type.school.id}` : ''
    resourceId = resourceId ? `&teaching_resource_id=${resourceId}` : ''
    studentId = studentId ? `&student_id=${studentId}` : ''

    this.setState({loading: true})
    searchInput && searchInput.blur()

    return API.get(`/v3/search.json?${query}${schoolId}${resourceId}${studentId}${groupId}${bookmark}${exemplar}${order}${yeargroup}${student}&from=${page}&limit=${limit}`)
      .then(({data}) => {
        data.works.length
          ? this.setState({loading: false, page: page + limit})
          : this.stopScroll()
        schoolId && this.getSchoolInfo(this.props.match.params.schoolId)
        return data.works
      })
      .catch(() => this.setState({ loading: false, works: [] }))
  }

  closeSchool () {
    this.setState({schoolId: null, school: {}, filters: {groupId: null}}, this.cleanSearch())
  }

  onBookmark (index) {
    return (work) => (work.bookmarked_by_me
      ? API.delete(`/v3/works/${work.id}/remove_bookmark`)
      : API.post(`/v3/works/${work.id}/bookmark`))
      .then(() =>
        this.setState({ works: update(this.state.works, {[index]: {bookmarked_by_me: {$set: !work.bookmarked_by_me}}}) }))
  }

  onSchoolFollow (follow) {
    this.setState({school: update(this.state.school, {followed_by_current_account: {$set: follow}})})
  }

  render () {
    var workList = this.state.works && this.state.works.map((work, index) =>
      (work && work.id && <li key={index}>
        <Link to={{pathname: `/works/${work.id}`, state: this.state}}>
          <WorkTile {...work} onBookmark={this.onBookmark(index)} />
        </Link>
      </li>))

    let workEnvelopes = this.state.works && this.state.works.slice(0,10).map((work, index) =>
      (work && work.id && <li key={index}>
        <Link to={{pathname: `/works/${work.id}`, state: this.state}}>
          <WorkEnvelope {...work} inSchool={true} />
        </Link>
      </li>))

    let writers = <div styleName='envelopes'>
                  <div styleName='wrapper'><h3 styleName='subTitle'>Our writers of the week!</h3></div>
          <ul styleName='wrapper'>
            {workEnvelopes}
          </ul>
        </div>

    return (
      <div>
        <PendingTeacherBar />
        {/* this.state.user && this.state.user.id && <Campaigns /> */}
        {this.state.resourceId && <ResourceHeader resourceId={this.state.resourceId} />}
        {this.state.studentId && <StudentHeader studentId={this.state.studentId} />}
        {this.props.match.params.schoolId && <SchoolHeader {...this.state.school} closeSchool={this.closeSchool} user={this.state.user} onFollow={this.onSchoolFollow} />}
        {this.props.match.params.schoolId && <a href='https://www.pobble.com/pobble-celebration-pack' target="_blank" className='btn btn-default' styleName='celebrationPackButton'><FaDownload /> Download our celebration pack</a>}
        {this.props.match.params.schoolId && this.state.works.length > 0 && <div>{writers}</div>}
        {this.props.match.params.schoolId && this.state.works.length > 0 && <h3 className='search__heading'>More work</h3>}
        {(this.state.works.length > 0 || !this.state.loading) && <SearchHeader onFilterSelect={this.onFilterSelect} onSubmit={this.goToQuery} {...this.state} />}

        <section className='search-container'>
          <Masonry className={'tile-wall'} elementType={'ul'} options={masonryOptions}>{workList}</Masonry>
          {this.state.loading && !this.state.done && <div className='spinner' style={{height: this.state.page === 0 ? '90%' : 'auto'}} />}
          {!this.state.loading && (!this.state.works || !this.state.works.length) && <NotFound {...this.state} fallback={this.goToQuery} />}
        </section>
      </div>
    )
  }
}

Search.propTypes = {
  params: PropTypes.object
}

export default withMe(Search)



// WEBPACK FOOTER //
// ./components/search/Search.js